export type Rating = 'all' | 'safe' | 'goon';

export interface RatingOption {
  id: Rating;
  label: string;
  tags: string;
}

export const RATING_OPTIONS: RatingOption[] = [
  {
    id: 'all',
    label: 'All',
    tags: '',
  },
  {
    id: 'safe',
    label: 'Safe',
    tags: 'rating:general',
    // Alternative: '-rating:explicit -rating:questionable'
    // Alternative: 'rating:g' or 'rating:s'
  },
  {
    id: 'goon',
    label: 'Goon',
    tags: 'rating:explicit',
    // Alternative: 'rating:e'
  },
];

export const getRatingTags = (rating: Rating): string => {
  const option = RATING_OPTIONS.find(opt => opt.id === rating);
  return option ? option.tags : '';
};

